QACommand = xClass("QACommand")
var _instance = null
QACommand.getInstance = function () {
    if (!_instance) {
        _instance = QACommand.new()
    }
    return _instance
}
QACommand.prototype.ctor = function () {

}
/**
 * 
 * @param {*} str ForceSetStep$$1 代表：ForceSetStep(1)  ($$分割方法名称和参数 多个参数用&&分割) 方法名称可以自行映射
 * @returns 
 */
QACommand.prototype.analyzeCommand = function (str) {
    console.log("[QACommand]analyzeCommand str ", str)
    if (!str) return
    let arr = str.split("$$")
    let key = arr[0]
    let parameter = arr[1]
    console.log("[QACommand]analyzeCommand key = " + key + " parameter = " + parameter)
    this.runCommand(key, parameter)
    return key
}

QACommand.prototype.runCommand = function (key, parameter) {
    let fKey = ("run" + key).toLowerCase()
    if(this[fKey]){
        this[fKey](parameter)
    }else{
        console.log("[QACommand]runCommand no function ", fKey) 
    }
}

QACommand.prototype.runsetstep = function (parameter) {
    let arr = parameter.split("&&")
    ForceSetStep(arr[0])
}

QACommand.prototype.runwinstar = function (parameter) {
    ForceWinWithStar(parseInt(parameter))
}

QACommand.prototype.runseterrktx = function (parameter) {
    window.ErrKtx = parameter
}

QACommand.prototype.runinfprop = function (parameter) {
    ForceUnlimitUseProp()
}

module.exports = QACommand